<template>
  <div class="">
    <div class="tableDiv">
      <div class="table-header"><span class="tableheading">PurchaseRequisitionView (1-25/26)</span> </div>
      <b-table class="requisit" striped hover :items="PendPR" :fields="fields" selectable
      @row-selected="onRowSelected">
      <template slot="selected">
        <img src="img/docimg.gif" />
    </template>
      <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <a-checkbox :checked="rowSelected" @change="onChange">
          </a-checkbox>
        </template>
        <template v-else>
          <a-checkbox @change="onChange">
          </a-checkbox>
        </template>
      </template>
      </b-table>
      <span class="page"><span style="color:blue; margin-right: 5px;">1</span> 2</span>
    </div>



  </div>
</template>

<script>
export default {
  name: 'Requisition',
  data() {
      return {
        fields: ['selected', 'Pur_Requisition_No', 'Pur_Requisition_Date', 'Pur_Requisition_Type', 'Ref_No', 'Authorized', 'Authorization_Stage'],
        PendPR: [
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/052/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '11', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/052/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '11', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/052/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '11', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/052/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '11', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/052/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '11', Authorized: 'Yes', Authorization_Stage: '3' },
        ],
        selected: []
      }
    },
    methods: {
        onRowSelected(items) {
          this.selected = items
        },
        onChange(e) {
          this.checked = e.target.checked;
        },
      }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tableDiv{
  border: 1px solid;
  margin: 20px 0px 15px 5px;
  border-radius: 5px;
  text-align: left;
}
.table-header{
  background: #bdc7d6;
  text-align: left;
  border-bottom: 1px solid;
}
.tableimg{
  padding-left: 10px;
    padding-right: 10px;
    width: 30px;
    margin-top: -4px;
}
.tableheading{
  padding-left: 10px;
      font-size: 14px;
    font-weight: 700;
}
.table-body{
      text-align: center;
    padding: 5px;
}
.table-body select, .table-body input{
  border: 2px inset;
}
.page{
  padding-top: 5px !important;
  padding-left: 15px !important;
   font-weight:500;
    font-size: 12px;
}
.ielogo{
  width: 20px;
  margin-left: 5px;
}
.toolicons{
      position: absolute;
      right: 3px;
    top: -2px;
}
.toolicons .anticon{
      background: #c0c0c0;
    border: 2px outset;
    margin-right: 2px;
    color: #333;
}
.glass{
    position: relative;
    display: inline-block;
    padding: 2px 18px;
    border: 0;
    background-color: green;
    background-image: linear-gradient(lightgreen,#66b266,lightgreen);
    text-decoration: none;
        color: #333;
    font-size: 12px;
    font-family: sans-serif;
    font-weight: 700;
    box-shadow: rgb(0 0 0 / 25%) 1.95px 1.95px 2.6px;
    border-radius: 15px;
}
select {

  /* styling */
  background-color: white;
  border: thin solid blue;
  border-radius: 4px;
  display: inline-block;
  font: inherit;
  line-height: 1.5em;
  padding: 0em 3.5em 0em 0.5em;

  /* reset */

  margin: 0;      
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
}
select.round {
background-image: linear-gradient( 
45deg, transparent 30%, gray 74%), linear-gradient( 
135deg, gray 68%, transparent 36%), radial-gradient(#c0c0c0 100%, transparent 50%);
    background-position: calc(100% - 12px) calc(1em + -5px), calc(100% - 8px) calc(1em + -5px), calc(100% - 0em) 0em;
    background-size: 5px 5px, 5px 5px, 1.5em 1.5em;
    background-repeat: no-repeat;
    border: 2px inset;
    }
</style>
